import { ThunkAction } from 'redux-thunk'
import { RootState } from '..'
import { employeeApi } from '../../apis/employeeApi'
import { EmployeeEntity, EmployeeFilter } from '../../models'
import {
  EmployeeAction,
  SET_EMPLOYEES,
  SET_EMPLOYEES_LOADED,
  SET_EMPLOYEE_FILTER,
  SET_SELECTED_EMPLOYEE,
} from '../types'
import { loadProfile } from './authAction'

export const setEmployees = (employees: EmployeeEntity[]): EmployeeAction => ({
  type: SET_EMPLOYEES,
  payload: employees,
})

export const loadEmployees = (): ThunkAction<
  void,
  RootState,
  null,
  EmployeeAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setEmployeesLoaded(false))
      const resp = await employeeApi.getEmployees()
      dispatch(setEmployees(resp.data.data))
    } catch (e) {
      if (e && e.response && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await employeeApi.getEmployees()
        dispatch(setEmployees(resp.data.data))
      }
    } finally {
      dispatch(setEmployeesLoaded(true))
    }
  }
}

export const setEmployeelFilter = (
  employeeFilter: EmployeeFilter
): EmployeeAction => ({
  type: SET_EMPLOYEE_FILTER,
  payload: employeeFilter,
})

export const setSelectedEmployee = (
  selectedEmployee?: EmployeeEntity
): EmployeeAction => ({
  type: SET_SELECTED_EMPLOYEE,
  payload: selectedEmployee,
})

export const setEmployeesLoaded = (loaded: boolean): EmployeeAction => ({
  type: SET_EMPLOYEES_LOADED,
  payload: loaded,
})
